var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 6.0026V1.33594L6.66675 2.66927",
    stroke: "#0B75C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.33594L9.33333 2.66927",
    stroke: "#0B75C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32007 8.66406H4.26007C4.5134 8.66406 4.74007 8.80406 4.8534 9.03073L5.6334 10.5907C5.86007 11.0441 6.32007 11.3307 6.82674 11.3307H9.18007C9.68674 11.3307 10.1467 11.0441 10.3734 10.5907L11.1534 9.03073C11.2667 8.80406 11.5001 8.66406 11.7467 8.66406H14.6534",
    stroke: "#0B75C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66659 3.42188C2.30659 3.76854 1.33325 5.15521 1.33325 8.00188V10.0019C1.33325 13.3352 2.66659 14.6685 5.99992 14.6685H9.99992C13.3333 14.6685 14.6666 13.3352 14.6666 10.0019V8.00188C14.6666 5.15521 13.6933 3.76854 11.3333 3.42188",
    stroke: "#0B75C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectSend);
export default __webpack_public_path__ + "static/media/direct-send.1af9af294f4151785b523504bcdbdded.svg";
export { ForwardRef as ReactComponent };